import React, { useEffect } from "react";
import { useAtom } from "jotai";
import { currentUserAtom, spaceListAtom } from "../jotai/atoms";
import { styled } from "../stitches.config";
import { useSpaceInfo } from "../roomservice/maps";
import { BOT_NAME, LOCAL_STORAGE_KEYS } from "../consts";
import { Size } from "../types";
import { useAuth } from "../auth/useAuth";
import Loader from "../components/Loader";
import { generatenewSpaceId } from "./Home";
import { Button } from "../components/Button";
import LogOutButton from "./LogOutButton";
import { useHistory } from "react-router-dom";
const flash_api_key = "e32694e9ba064287922eb31970fa2d04";
export default function BigSpaceList() {
  const [currentUser] = useAtom(currentUserAtom);
  const [spaces, setSpaceList] = useAtom(spaceListAtom);

  useEffect(() => {
    const spaces = window.localStorage.getItem(LOCAL_STORAGE_KEYS.HISTORY);
    // Filter out old instances of current space
    const newSpaces = spaces ? JSON.parse(spaces) : [];
    window.localStorage.setItem(
      LOCAL_STORAGE_KEYS.HISTORY,
      JSON.stringify(newSpaces)
    );
    setSpaceList(newSpaces);
  }, [setSpaceList]);

  const history = useHistory();

  function createSpace() {
    const newSpaceId = generatenewSpaceId();
    history.push("/space/" + newSpaceId);
  }

  const { auth, hasFetched } = useAuth();
  if (!currentUser) return <>&nbsp;</>;
  if (!hasFetched) return <Loader>Loading...</Loader>;

  return (
    <>
      <h1>
        Recent Spaces{" "}
        {auth && (
          <>
            <Button color="primary" onClick={createSpace}>
              Create Space
            </Button>
            <LogOutButton />
          </>
        )}
      </h1>

      {spaces && (
        <SpaceContainer>
          {spaces.slice(0, 16).map((spaceId) => (
            <SpaceItem key={spaceId} id={spaceId} />
          ))}
        </SpaceContainer>
      )}
      {spaces.length === 0 && <Empty>No recent spaces.</Empty>}
    </>
  );
}

interface SpaceItemProps {
  id: string;
}

function buildUrl(size: Size, url: string) {
  return `https://api.apiflash.com/v1/urltoimage?access_key=${flash_api_key}\
&url=${url}\
&width=${size.width * 2}\
&height=${size.height * 2}\
&ttl=2592000\
&scroll_page=true\
&css=${encodeURI("html{transform: translateX(-75%) scale(0.5);}")}`;
}

function SpaceItem({ id }: SpaceItemProps) {
  const [info] = useSpaceInfo(id);
  return (
    <SpaceContainerItem as="a" href={`/space/${id}`}>
      <Label>{info?.name || id.slice(0, 6)}</Label>
      <Img
        src={buildUrl(
          { width: 300, height: 300 },
          `https://sprout.place/space/${id}?name=${BOT_NAME}`
        )}
        alt={`screenshot of space`}
      />
    </SpaceContainerItem>
  );
}

const SpaceContainer = styled("div", {
  display: "flex",
  flexWrap: "wrap",
  margin: "$3",
});

const SpaceContainerItem = styled("div", {
  width: 300,
  height: 300,
  flexGrow: 1,
  border: "1px solid $brown",
  margin: "$1",
  boxShadow: "$cursor",
  overflow: "hidden",
});
const Empty = styled("div", {
  padding: "$6 $2",
  textAlign: "center",
});

const Img = styled("img", {
  width: "100%",
});

const Label = styled("h1", {
  position: "absolute",
});
